import { BaseCharacterGender } from "mmo-common";
import { BaseCharacterAnimation } from "../base-character/baseCharacter.gameObject";

/**
 * Stores the animation and the player speed that the animation
 * perfectly matches
 */
const MOVEMENT_ANIMATION_BASE_PLAYER_SPEED: {
  [animation in BaseCharacterAnimation]?: {
    [gender in BaseCharacterGender]?: number;
  };
} = {
  baseWalk: {
    female: 30,
    male: 30,
  },
  twoHandedWeaponRun: {
    female: 50,
    male: 50,
  },
  ninjaRun: {
    female: 50,
    male: 50,
  },
  staffRun: {
    female: 20,
    male: 20,
  },
};

/**
 * Returns the speed to play a movement animation
 */
export function getMovementAnimationSpeed({
  animation,
  gender,
  speed,
}: {
  animation: BaseCharacterAnimation;
  gender: BaseCharacterGender;
  speed: number;
}) {
  const baseSpeed = MOVEMENT_ANIMATION_BASE_PLAYER_SPEED[animation]?.[gender];
  if (!baseSpeed) {
    return 1;
  }
  return speed / baseSpeed;
}
